import type { PropsWithChildren } from 'react';

import classNames from 'classnames';

import { TransparentButton } from 'src/app/components/Elements/Button/TransparentButton';

import styles from './styles.module.scss';

import { PaymentCardItem } from '.';

interface CardDeleteButtonProps {
  handleDelete: () => void;
  ['data-testid']?: string;
}

export const CardItemWithDeleteButton = (props: PropsWithChildren<CardDeleteButtonProps>) => (
  <PaymentCardItem>
    {props.children}

    <TransparentButton data-testid={props['data-testid'] ?? 'selectMenu'} onClick={props['handleDelete']}>
      <p className={classNames(styles.button, styles.delete)}>Delete</p>
    </TransparentButton>
  </PaymentCardItem>
);
